import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import Meta from '../components/Meta';
import ResponsiveImage from '../components/ResponsiveImage';

export default function UnderConstruction() {
  const { t } = useTranslation();

  return (
    <section className="bg-white min-h-[calc(100vh-4rem)] flex items-center">
      <Meta titleKey="underConstruction.title" descKey="underConstruction.description" noIndex />
      <div className="max-w-7xl mx-auto w-full flex flex-col items-center justify-center gap-8 px-4 lg:px-8 text-center">
        {/* mascot animation & responsive sizing */}
        <motion.div
          className="w-full max-w-xs md:max-w-lg lg:max-w-xl select-none mx-auto mb-8"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
        >
          <ResponsiveImage
            srcBase="/images/mascot-hero"
            alt="Neko-chan mascot coming soon"
            loading="lazy"
          />
        </motion.div>

        <h1 className="font-semibold text-brand mb-4 leading-tight text-[2.75rem] md:text-[4rem]">
          {t('underConstruction.title')}
        </h1>

        <p className="text-xl text-gray-700 mb-4 max-w-md">
          {t('underConstruction.description')}
        </p>
      </div>
    </section>
  );
}
